import script from "./BuyGoodscf.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyGoodscf.vue?vue&type=script&setup=true&lang=js"

import "./BuyGoodscf.vue?vue&type=style&index=0&id=033496b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-033496b2"]])

export default __exports__